import React, { useState } from 'react';
import Layout from '../components/Layout';
import { tax } from '../services/api';

const TaxExport: React.FC = () => {
  const now = new Date();
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [year, setYear] = useState(now.getFullYear());
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const res = await tax.export(year, month);
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `futuresaints_tax_${month}_${year}.xlsx`;
      a.click();
    } catch (e) {}
    setLoading(false);
  };

  const inputStyle: React.CSSProperties = { padding: '10px 14px', background: '#0e0e1a', border: '1px solid #1c1c2e', borderRadius: 10, color: '#f0f0ff', fontSize: 13, fontFamily: "'DM Sans', sans-serif", outline: 'none' };

  return (
    <Layout title="Tax Export">
      <div style={{ maxWidth: 600 }}>
        <div style={{ background: '#0e0e1a', border: '1px solid #1c1c2e', borderRadius: 16, padding: 32 }}>
          <div style={{ fontFamily: "'Cabinet Grotesk', sans-serif", fontSize: 18, fontWeight: 800, color: '#f0f0ff', marginBottom: 8 }}>Download Tax Report</div>
          <div style={{ fontSize: 13, color: '#4a4a6a', marginBottom: 28, lineHeight: 1.6 }}>
            Exports all delivered + paid orders for the selected month with IGST/CGST/SGST breakdown. Gujarat orders split into CGST + SGST (2.5% each). All other states use IGST (5%).
          </div>
          <div style={{ display: 'flex', gap: 12, marginBottom: 24 }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 11, color: '#4a4a6a', textTransform: 'uppercase', letterSpacing: 1, display: 'block', marginBottom: 8 }}>Month</label>
              <select value={month} onChange={e => setMonth(Number(e.target.value))} style={{ ...inputStyle, width: '100%' }}>
                {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'].map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
              </select>
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 11, color: '#4a4a6a', textTransform: 'uppercase', letterSpacing: 1, display: 'block', marginBottom: 8 }}>Year</label>
              <input type="number" value={year} onChange={e => setYear(Number(e.target.value))} style={{ ...inputStyle, width: '100%', boxSizing: 'border-box' }} />
            </div>
          </div>
          <button onClick={handleExport} disabled={loading} style={{ width: '100%', padding: 14, background: loading ? '#1c1c2e' : 'linear-gradient(135deg,#34d399,#059669)', border: 'none', borderRadius: 12, color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}>
            {loading ? 'Generating...' : '⬇ Download Excel'}
          </button>
        </div>

        <div style={{ background: '#0e0e1a', border: '1px solid #1c1c2e', borderRadius: 16, padding: 24, marginTop: 16 }}>
          <div style={{ fontFamily: "'Cabinet Grotesk', sans-serif", fontSize: 14, fontWeight: 800, color: '#f0f0ff', marginBottom: 14 }}>Report Includes</div>
          {['Order ID', 'Customer Name', 'Total Amount (₹)', 'Quantity', 'Amount Before Tax', 'IGST', 'CGST', 'SGST', 'Province', 'Payment Method'].map((col, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 0', borderBottom: '1px solid #1c1c2e' }}>
              <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#6e8efb' }} />
              <span style={{ fontSize: 13, color: '#4a4a6a' }}>{col}</span>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default TaxExport;
